import { render, staticRenderFns } from "./AdsSearchTop.vue?vue&type=template&id=af484222&"
import script from "./AdsSearchTop.vue?vue&type=script&lang=js&"
export * from "./AdsSearchTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports